import React from 'react';
import styled from 'styled-components';
import { basicColor, radius } from '@/styles/template';
import Grid from '@/components/molecules/Grid';
import { AccentTextS } from '@/pages/designSystem/Fonts';

const Wrapper = styled.div`
	width: 100%;
  	position: relative;
  	padding: 6rem 4rem 4rem;
	border-radius: ${radius.normal};
  background: ${props => props.theme.color.Item};
	box-shadow: ${props => props.theme.boxShadow.Long};
	overflow: hidden;
  z-index: 0;
  
  & a {
    color: ${basicColor.primary}
  }
`;

const Number = styled.div`
	position: absolute;
	background: ${basicColor.primaryTransparent};
	color: ${basicColor.primary};
	padding: 1rem 2rem;
	top: 0;
	left: 0;
	border-radius: 0 0 3rem 0;
  z-index: 1;
`;

type Props = {
	children: React.ReactNode;
	number: number
}
const StepCard: React.FC<Props> = ({ children, number }) => {
	return (
		<Wrapper>
			<Grid col={'1'} gap={'3'} margin={'2'} centeredContent>
				{children}
			</Grid>
			<Number><AccentTextS>{number}</AccentTextS></Number>

		</Wrapper>
	)
}

export default StepCard